import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './App.css';
// import Home from '../src/pages/Home';
// import Onboarding from '../src/pages/Onboarding';
// import Logoutsave from '../src/pages/Logoutsave';
import AppRoutes from './web/Routes';
import Notifications from 'react-notify-toast';
import Loader from '../src/web/framework/Loader';
import { storeState } from '../src/store/hooks';
import Etcetras from '../src/web/framework/Etcetras';
// import EditDoctorProfile from '../src/web/components/EditDoctorProfile';
const Home = React.lazy(() => import('../src/pages/Home'));
const Onboarding = React.lazy(() => import('../src/pages/Onboarding'));
const Logoutsave = React.lazy(() => import('../src/pages/Logoutsave'));
const EditDoctorProfile = React.lazy(() => import('../src/web/components/EditDoctorProfile'));

const App: React.FC = (): JSX.Element => {
  const loader = storeState((state: any) => state.app.loader);
  const loaderText = storeState((state: any) => state.app.loaderText);

  return (
    <React.Fragment>
      <Notifications options={{ zIndex: 1040, top: '18px' }} />
      {/* <Router> */}
        <Suspense fallback={<div><Loader loaderText={loaderText} /></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/doctorlogin" element={<Onboarding />} />
            <Route path="/patientlogin" element={<Onboarding />} />
            <Route path="/adminlogin" element={<Onboarding />} />
            <Route path="/companylogin" element={<Onboarding />} />
            <Route path="/doctorlogin/signup" element={<Onboarding />} />
            <Route path="/patientlogin/signup" element={<Onboarding />} />
            <Route path="/adminlogin/signup" element={<Onboarding />} />
            <Route path="/forgotpassword/:userType" element={<Onboarding />} />
            <Route path="/register" element={<Onboarding />} />
            <Route path="/logoutsave" element={<Logoutsave />} />
            <Route path="/signthanks" element={<Onboarding />} />
            <Route path="/registerDetails/:UserGUID" element={<EditDoctorProfile />} />
            <Route path="/resetpassword/:UserGuid/:VGuid" element={<Onboarding />} />
          </Routes>
        </Suspense>
        <Etcetras />
        <AppRoutes />
      {/* </Router> */}
      {loader && <Loader loaderText={loaderText} />}
    </React.Fragment>
  );
}

export default App;